import { html } from '@polymer/polymer/polymer-element.js';
import { KatapultWidget } from './katapult-widget';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import '@polymer/paper-input/paper-textarea';
import '@polymer/iron-icons/av-icons';
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/iron-form/iron-form.js';
import '@polymer/neon-animation/neon-animation.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '../../katapult-auth/katapult-auth';
import '../../katapult-drop-down/katapult-multi-drop-down.js';
import '../../katapult-toolbar/katapult-toolbar';
import '../../katapult-map-icons/katapult-map-icons';
import '../../paper-table/paper-table';
import '../../code-requests/katapult-task-submission.js';
import '../../style-modules/paper-table-style';
import '../../style-modules/paper-dialog-style';
import '../../style-modules/paper-menu-button-style.js';
import '../../katapult-elements/katapult-button.js';
import { DateTime } from 'luxon';

/* global firebase, FirebaseWorker, k, katapultAuth */

class KatapultProficiencyWidget extends KatapultWidget {
  static get headerTemplate() {
    return html` Proficiency Report`;
  }

  static get contentTemplate() {
    return html`
      <style>
        [hidden] {
          display: none;
        }
        paper-checkbox {
          --primary-color: var(--secondary-color);
        }
      </style>
      <iron-form id="filterForm">
        <form>
          <div style="display: flex; align-items: center;">
            <katapult-drop-down
              id="dateRangeInput"
              label="Date Range"
              items="[[dateRangeList]]"
              value="katapult_last_7"
              no-clear
              label-path="label"
              value-path="value"
              sort="[[sortByOrder]]"
              style="flex: 2;"
              on-value-changed="filterChanged"
            ></katapult-drop-down>
            <paper-input
              id="startDateInput"
              label="Start Date"
              type="date"
              disabled
              style="flex: 1; margin-left: 10px;"
              on-value-changed="filterChanged"
            ></paper-input>
            <paper-input
              id="endDateInput"
              label="End Date"
              type="date"
              disabled
              style="flex: 1; margin-left: 10px;"
              on-value-changed="filterChanged"
            ></paper-input>
          </div>
          <katapult-multi-drop-down
            id="uidInput"
            label="User(s)"
            disabled="[[!isUserKpiAdmin]]"
            items="[[userList]]"
            no-clear
            label-path="email"
            value-path="uid"
            display-label
            count-limit="10"
            seed-value="[[user.uid]]"
            on-value-changed="filterChanged"
          ></katapult-multi-drop-down>
          <paper-checkbox id="showAllRowsInput" style="padding: 20px 0;" on-checked-changed="filterChanged">Show all rows</paper-checkbox>
          <paper-checkbox id="showReviewedPolesInput" style="padding: 20px 0; margin-left: 20px;" on-checked-changed="filterChanged"
            >Only show reviewed poles</paper-checkbox
          >
          <div style="display: flex; justify-content: flex-end; align-items: center;">
            <span hidden="[[!_filtersChanged]]" style="margin-right: 10px; font-style: italic;"
              >Filters changed, click apply to update</span
            >
            <katapult-button color="var(--secondary-color)" loading="[[loadingDataRows]]" on-click="getDataRows" icon="filter_list"
              >Apply</katapult-button
            >
          </div>
        </form>
      </iron-form>
    `;
  }

  static get bodyTemplate() {
    return html`
      <style>
        [hidden] {
          display: none;
        }
        paper-spinner {
          --paper-spinner-color: var(--secondary-color);
        }
        paper-row {
          height: auto;
        }
        paper-cell[textarea] {
          padding: 0;
        }
        paper-checkbox {
          --primary-color: var(--secondary-color);
        }
        paper-row[completed] {
          opacity: 0.7;
        }
        paper-row[completed] paper-textarea {
          --iron-autogrow-textarea: {
            text-decoration: line-through;
          };
        }
        [slot='sortable'] paper-row {
          transition: background-color 0.3s;
        }
        paper-row:hover {
          z-index: 2;
        }
        [slot='sortable'] paper-row:not([slot='after']):hover,
        .dragging {
          background: var(--paper-grey-50);
        }
        [hover] {
          opacity: 0;
          transition: opacity 0.3s;
        }
        [hide-hover] {
          opacity: 1;
          transition: opacity 0.3s;
        }
        [slot='sortable'] paper-row:not([slot='after']):hover [hover] {
          opacity: 1;
        }
        [slot='sortable'] paper-row:hover [hide-hover] {
          opacity: 0;
        }
        paper-item:hover {
          cursor: pointer;
        }
        iron-icon[red] {
          color: var(--paper-red-500);
        }
        iron-icon[green] {
          color: var(--paper-green-500);
        }
        .unreadHalo {
          position: absolute;
          box-sizing: border-box;
          width: 30px;
          height: 30px;
          border-radius: 30px;
          margin: 0;
          border: 3px solid var(--secondary-color);
        }
        [flex-column] {
          display: flex;
          flex-direction: column;
        }
      </style>
      <katapult-firebase-worker
        path="photoheight/company_space/[[userGroup]]/project_tracking/target_hourly_rate"
        data="{{targetHourlyRates}}"
      ></katapult-firebase-worker>
      <paper-table dividers>
        <paper-row raised-on-scroll grey>
          <paper-cell>Type</paper-cell>
          <paper-cell>User Count</paper-cell>
          <paper-cell style="align-items: unset;">Proficiency<sup>1</sup></paper-cell>
          <paper-cell>MKP</paper-cell>
          <paper-cell>Team Count</paper-cell>
          <paper-cell style="align-items: unset;">Proficiency<sup>1</sup></paper-cell>
          <paper-cell>MKP</paper-cell>
        </paper-row>

        <template is="dom-repeat" items="[[dataRows]]" as="row" mutable-data>
          <paper-row white>
            <paper-cell>[[row.label]]</paper-cell>
            <paper-cell>[[row.user.count]]</paper-cell>
            <paper-cell>[[row.user.proficiency]]</paper-cell>
            <paper-cell>[[row.user.mkp]]</paper-cell>
            <paper-cell>[[row.team.count]]</paper-cell>
            <paper-cell>[[row.team.proficiency]]</paper-cell>
            <paper-cell>[[row.team.mkp]]</paper-cell>
          </paper-row>
        </template>

        <template is="dom-if" if="[[dataRows.length]]">
          <paper-row white>
            <paper-cell style="font-weight: bold;">Totals</paper-cell>
            <paper-cell></paper-cell>
            <paper-cell></paper-cell>
            <paper-cell>[[getKpTotal('user', dataRows)]]</paper-cell>
            <paper-cell></paper-cell>
            <paper-cell></paper-cell>
            <paper-cell>[[getKpTotal('team', dataRows)]]</paper-cell>
          </paper-row>
        </template>

        <template is="dom-if" if="[[!dataRows.length]]">
          <paper-row white>
            <paper-cell center style="color: var(--primary-text-color-faded);">[[emptyDataMessage]]</paper-cell>
          </paper-row>
        </template>

        <paper-row>
          <paper-cell center white>
            <katapult-button
              id="reloadDataButton"
              color="var(--secondary-color)"
              loading="[[loadingDataRows]]"
              on-click="getDataRows"
              icon="cloud_download"
            >
              <span hidden="[[dataRows.length]]">Load</span>
              <span hidden="[[!dataRows.length]]">Reload</span>
            </katapult-button>
            <span id="reloadMessage" style="margin-left: 10px; color: var(--secondary-text-color);"></span>
          </paper-cell>
        </paper-row>
      </paper-table>
    `;
  }

  static get footNote() {
    return html`
      <div style="margin-top: 4px; font-size: 12px;">
        <sup>1</sup> "Proficiency" refers to the percent of actions that do not have feedback.
      </div>
    `;
  }

  static get properties() {
    return {
      paperHeader: {
        type: Boolean,
        value: true
      },
      paperTableBody: {
        type: Boolean,
        value: true
      },
      _filtersChanged: {
        type: Boolean,
        value: true
      },
      userGroup: String,
      dataRows: {
        type: Array,
        value: []
      },
      dateRangeList: {
        type: Array,
        value: [
          {
            value: 'katapult_last_7',
            label: 'This Katapult Week',
            order: 1
          },
          {
            value: 'last_7',
            label: 'This Calendar Week (Last 7 Days)',
            order: 2
          },
          {
            value: 'katapult_prev_7',
            label: 'Last Katapult Week',
            order: 3
          },
          {
            value: 'prev_7',
            label: 'Last Calendar Week',
            order: 4
          },
          {
            value: 'last_30',
            label: 'This Month (Last 30 Days)',
            order: 5
          },
          {
            value: 'custom',
            label: 'Custom',
            order: 6
          }
        ]
      },
      emptyDataMessage: {
        type: String,
        value: 'Click "Load" to generate your proficiency report...'
      },
      isUserKpiAdmin: {
        type: Boolean,
        computed: 'getIsUserKpiAdmin(user, catalogData)'
      },
      rowDefinitions: {
        type: Array,
        value: []
      }
    };
  }

  static get observers() {
    return ['updateUserList(userGroup)', 'updateReviewedNodesCache(actionData)', 'updateRowDefinitions(userGroup)'];
  }

  ready() {
    super.ready();
  }

  equal(a, b) {
    return a == b;
  }

  filterChanged(e) {
    let startDateInput = this.shadowRoot.querySelector('#startDateInput');
    let endDateInput = this.shadowRoot.querySelector('#endDateInput');
    if (e.currentTarget.id == 'dateRangeInput' && startDateInput && endDateInput) {
      if (e.detail.value == 'custom') {
        startDateInput.disabled = false;
        startDateInput.required = true;
        endDateInput.disabled = false;
        endDateInput.required = true;
      } else {
        startDateInput.disabled = true;
        startDateInput.required = false;
        endDateInput.disabled = true;
        endDateInput.required = false;
      }
    }
    this._filtersChanged = true;
  }

  filterForReviewedPoles(actions) {
    // If the reviewed nodes cache doesn't exist, just return the passed-in actions
    if (!this.reviewedNodesCache) return actions;
    let filteredActions = [];
    // Map action ids to "reviewer" values
    let reviewMap = Object.fromEntries(this.rowDefinitions.map((r) => [r.actionId, r.reviewer]));
    // For each action, determine if the associated node has been appropriately reviewed
    for (const action of actions) {
      let reviewer = reviewMap[action.action_id];
      if (!reviewer) continue;
      if (this.reviewedNodesCache[reviewer].includes(action.node_id)) filteredActions.push(action);
    }
    return filteredActions;
  }

  getDatesAndTimes() {
    let startDate = this.shadowRoot
      .querySelector('#startDateInput')
      .value.split('-')
      .map((num) => parseInt(num, 10));
    // let startTime = this.shadowRoot.querySelector('#startTimeInput').value.split(':').map(num => parseInt(num, 10));
    let endDate = this.shadowRoot
      .querySelector('#endDateInput')
      .value.split('-')
      .map((num) => parseInt(num, 10));
    // let endTime = this.shadowRoot.querySelector('#endTimeInput').value.split(':').map(num => parseInt(num, 10));
    // return [new Date(startDate[0], startDate[1] - 1, startDate[2], startTime[0], startTime[1], 0, 0), new Date(endDate[0], endDate[1] - 1, endDate[2], endTime[0], endTime[1], 59, 999)];
    return [new Date(startDate[0], startDate[1] - 1, startDate[2]), new Date(endDate[0], endDate[1] - 1, endDate[2])];
  }

  async getDataRows(e) {
    let buttonId = e.currentTarget.id;
    // Validate the filter form before doing anything else
    if (!this.shadowRoot.querySelector('#filterForm').validate()) return;
    // Start the loading animation
    this.loadingDataRows = true;
    // If action data is undefined or the data filter has changed
    if (!this.actionData || this._filtersChanged || buttonId == 'reloadDataButton') await this.getActionData();
    let dataRows = [];
    // For each defined row
    for (const row of this.rowDefinitions) {
      let dataRow = { label: row.label };
      // Filter actions for the correct type and for their review status (if applicable)
      let actionsOfType = this.actionData.filter((a) => a.action_id == row.actionId && (!row.value || a.value == row.value));
      let teamMkp = actionsOfType.reduce(
        (total, action) => total + (row.milestone_value || 0) / this.getKpRate(action.timestamp.toDate()),
        0
      );
      if (this.shadowRoot.querySelector('#showReviewedPolesInput').checked) actionsOfType = this.filterForReviewedPoles(actionsOfType);
      // Get the team counts
      let teamCount = actionsOfType.length;
      dataRow.team = {
        count: teamCount,
        proficiency: this.getProficiencyString(teamCount, actionsOfType, '$all'),
        mkp: row.milestone_value ? Math.round(teamMkp) : '--'
      };
      // Get the user counts
      let userIds = Object.values(this.shadowRoot.querySelector('#uidInput').value) || [];
      let userActions = actionsOfType.filter((a) => userIds.includes(a.uid));
      let userCount = userActions.length;
      let userMkp = userActions.reduce(
        (total, action) => total + (row.milestone_value || 0) / this.getKpRate(action.timestamp.toDate()),
        0
      );

      dataRow.user = {
        count: userCount,
        proficiency: this.getProficiencyString(userCount, actionsOfType, userIds),
        mkp: row.milestone_value ? Math.round(userMkp) : '--'
      };
      if (dataRow.team.count) {
        dataRows.push(dataRow);
      }
    }
    // Filter for rows that have user data (unless we are showing all)
    if (!this.shadowRoot.querySelector('#showAllRowsInput').checked) dataRows = dataRows.filter((row) => !!row.user.count);
    // Set dataRows and update the ui
    this.dataRows = dataRows;
    if (this.dataRows.length == 0) this.emptyDataMessage = 'You do not have any tracked actions yet';
    this._filtersChanged = false;
    this.shadowRoot.querySelector('#reloadMessage').innerText =
      `Last updated: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;
    // Soft throttle reloads so users don't spam the update button
    if (buttonId == 'reloadDataButton') {
      this.shadowRoot.querySelector('#reloadDataButton').disabled = true;
      setTimeout(() => (this.shadowRoot.querySelector('#reloadDataButton').disabled = false), 30000);
    }
    this.loadingDataRows = false;
  }

  getKpRate(date) {
    let kpRate = this.targetHourlyRates[0].rate;
    for (let i = this.targetHourlyRates.length - 1; i >= 0; i--) {
      if (DateTime.fromISO(this.targetHourlyRates[i].start_date) < DateTime.fromJSDate(date)) {
        kpRate = this.targetHourlyRates[i].rate;
        break;
      }
    }
    return kpRate;
  }

  async getActionData() {
    // Short circuit if userGroup is null
    if (!this.userGroup) return;
    // Get the report ref
    let reportRef = this.getReportRef();
    let data = (await reportRef.get().then((s) => s.docs.map((doc) => Object.assign(doc.data(), { $key: doc.id })))) || [];
    this.actionData = data;
  }

  getKatapultEow(d) {
    let currentHour = d.getHours();
    let currentDay = d.getDay();
    let dayShift = 5 - currentDay;
    // If it is a Friday afternoon, bump to the next week
    if (dayShift == 0 && currentHour >= 12) dayShift = 7;
    let newDate = new Date(d);
    newDate.setDate(d.getDate() + dayShift);
    newDate.setHours(12, 0, 0, 0);
    return newDate;
  }

  getKpTotal(column) {
    return this.dataRows
      .map((row) => (typeof row[column].mkp == 'number' ? row[column].mkp : 0))
      .reduce((acc, current) => acc + current, 0);
  }

  getProficiencyString(count, actions, uids) {
    // If count is zero, return the n/a string
    if (!count) return '--';
    // Otherwise, get the proficiency
    let countWithFeedback = actions.filter((a) => (uids == '$all' || uids.includes(a.uid)) && !!a.feedback_ref).length;
    let proficiency = (count - countWithFeedback) / count;
    return `${(proficiency * 100).toFixed(2)}%`;
  }

  getReportRef() {
    let dateRange = this.shadowRoot.querySelector('#dateRangeInput').value;
    let oneKatapultWeekAgo, oneWeekAgo, twoKatapultWeeksAgo, twoWeeksAgo, oneMonthAgo;
    // Set the base ref
    let ref = firebase.firestore().collection(`companies/${this.userGroup}/action_tracking`);
    // Filter using specific date ranges
    switch (dateRange) {
      case 'katapult_last_7':
        oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        oneKatapultWeekAgo = this.getKatapultEow(oneWeekAgo);
        ref = ref.where('timestamp', '>=', oneKatapultWeekAgo);
        break;
      case 'last_7':
        oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        ref = ref.where('timestamp', '>=', oneWeekAgo);
        break;
      case 'katapult_prev_7':
        oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        oneKatapultWeekAgo = this.getKatapultEow(oneWeekAgo);
        twoWeeksAgo = new Date();
        twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
        twoKatapultWeeksAgo = this.getKatapultEow(twoWeeksAgo);
        ref = ref.where('timestamp', '>=', twoKatapultWeeksAgo).where('timestamp', '<', oneKatapultWeekAgo);
        break;
      case 'prev_7':
        oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        twoWeeksAgo = new Date();
        twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
        ref = ref.where('timestamp', '>=', twoWeeksAgo).where('timestamp', '<', oneWeekAgo);
        break;
      case 'last_30':
        oneMonthAgo = new Date();
        oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
        ref = ref.where('timestamp', '>=', oneMonthAgo);
        break;
      case 'custom':
        let [startDate, endDate] = this.getDatesAndTimes();
        ref = ref.where('timestamp', '>=', startDate).where('timestamp', '<', endDate);
        break;
    }
    // Return the filtered ref
    return ref;
  }

  getIsUserKpiAdmin(user, catalogData) {
    return catalogData?.admins?.[user?.uid] === true;
  }

  seedUidData() {
    if (this.user) this.set('defaultUserObject.-k000', this.user.uid);
  }

  sortByOrder(a, b) {
    return a.order - b.order;
  }

  updateReviewedNodesCache() {
    // Short circuit if action data is null
    if (!this.actionData) return;
    let reviewedNodesCache = { pe: {}, cu: {} };
    // Loop through the
    for (const action of this.actionData) {
      // PE Review
      if (action.action_id == '-McL2dn04zs9sUZ36PyE' && action.node_id) reviewedNodesCache.pe[action.node_id] = true;
      // CU Review
      if (action.action_id == 'CU_review' && action.node_id) reviewedNodesCache.cu[action.node_id] = true;
    }
    this.reviewedNodesCache = { pe: Object.keys(reviewedNodesCache.pe), cu: Object.keys(reviewedNodesCache.cu) };
  }

  async updateRowDefinitions() {
    // If userGroup is undefined, short-circuit
    if (!this.userGroup) return;
    // Get row definitions from firebase
    let model = await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/models/proficiency_report/default`)
      .once('value')
      .then((s) => s.val());
    this.rowDefinitions = model;
  }

  async updateUserList() {
    let users = await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/users`)
      .once('value')
      .then((s) => s.val());
    this.userList = Object.values(users);
  }
}
window.customElements.define('katapult-proficiency-widget', KatapultProficiencyWidget);
